export const en = {
  hashtags: 'hashtags',
  created_hashtags: 'Created Hashtags',
  analyzed_hashtags: 'analyzed hashtags',
  trashed_hashtags: 'Trashed hashtags',
  trending: 'trending',
  created_by: 'created_by',
  add_hashtag: 'Add New Hashtag',
  add_Hashtag: 'Add Hashtag',
  add_keyword: 'add keyword',
  edit_hashtag: 'Edit Hashtag',
  trashed: 'trashed',
  deleted_on: 'deleted on',
  set_name: 'set name',
  sets_words: 'Set Words',
  num_of_words: 'Number Of Words',
  num_usage: 'usage',
  search_by_hashtag: 'Search By Hashtag',
  modified_on: 'Modified On',
  word_name: 'Word Name',
  search_by_set: 'search by  name',
  likes_count: 'Likes Count',
  text_logs: 'Logs',
  num_words: 'NO. Of Words',
  platforms_sources: 'platforms sources',
  un_analyzed_hashtags: 'un-analyzed hashtags',
  select_data_you_want_regrab: 'select the data you want ro regrab',
  unnecessary_hashtags: 'unnecessary hashtags',
  trending_hashtags: 'trending hashtags',
  trending_hashtags_table: 'trending hashtags table',
  unnecessary: 'unnecessary',
  most_mentioned: 'most mentioned',
  longest_mentioned: 'Longest Mentioned',
  positive: 'Postive',
  neutral: 'Neutral',
  negative: 'Negative',
  trends: 'trends',
  sets_tables: 'Sets Table',
  edit_dashboard: 'Edit Dashboard',
  type_hashtag: 'Type hashtag',
  type_keywords: 'type keywords',
  This_field_is_required:
    'This field is required and minimum length is 2 chars',
  type_hashtag: 'Type hashtag',
  maximum_word: 'This field is required and maximum length is 150 chars',
  Add_negative_words: 'Add negative words',
  Add_neutral_words: 'Add neutral words',
  Add_positive_words: 'Add positive words',
  Add_negative_items: 'Add negative items',
  Add_neutral_items: 'Add neutral items',
  Add_positive_items: 'Add positive items',
  word_already_exists_in_a_column: 'word already exists !',
  hashtag_already_exists_in_a_column: 'hashtag already exists !',
  set_already_exists_in_a_column: 'set already exists !',
  csv_already_exists:
    'CSV file contains duplication or already exists in other column',
  analyzing: 'ANALYZING',
  go_back_until_we_finish: 'Go back until we finish',
  done_edit_dashboard_view: 'Edits done successfully',
  this_hashtag_already_exists_please:
    'this hashtag already exists,please add a unique hashtag',
  word: 'word',
  set: 'set',
  csv: 'csv',
  add_new_set: 'add new set',
  last_seen: 'Last Seen',
  country: 'Country',
  hashtag: 'Hashtag',
  mentions: 'Mentions',
  influencer: 'Influencer',
  followers: 'Followers',
  following: 'Following',
  are_you_sure_you_want_to_cancel: 'Are you sure you want to cancel?',
  hashtags_dashboard: 'hashtags dashboard',
  top_posts: 'top posts',
  male: 'Male',
  select_inf: 'Please select the main hashtag to merge to',
  merge_warning:
    '(Merging is final and irreversible. The merged hashtags will be deleted and cannot be added back.)',
  female: 'Female',
  search: 'search',
  tweet_title: 'tweet title',
  influencer_name: 'influencer name',
  likes: 'likes',
  retweets: 'Retweets',
  replies: 'replies',
  attachments: 'attachments',
  has_imgs: 'has {{count}} images',
  created_on: 'created on',
  hashtags_dashboard: 'hashtags dashboard',
  hashtags_table: 'hashtags table',
  top_posts: 'top posts',
  longest_trending: 'longest trending',
  hashtags_trending: 'Hashtags Trending 24',
  location: 'location',
  See_all: 'See all',
  hashtag_created: 'hashtag add successfully, go to ',
  hashtag_updated: 'edits done successfully, go to ',
  updated_done: 'edits done successfully',
  details_page: 'Details page',
  go_to: 'Go To',
  influencer_entity: 'influencer / entity',
  Most_Frequent_word: 'most frequent word',
  cant_view_sentiment:
    'can not view sentiment chart because hashtags are unAnalyzed',
  hashtags_dashboard: 'hashtags dashboard',
  top_posts: 'top posts',
  selected_worlds: 'selected worlds',
  moving_tweet: 'Moving tweets are saved successfully ',
  grabbing_hashtag: 'Working on grabbing hashtag ',
  merging_hashtag: 'Working on merging hashtags ',
  come_later: ' please try again after few minutes',
  grabbing_influencer: 'Working on grabbing influencer',
  grabbing_entity: 'Working on grabbing entity',
  hashtags_used: 'Hashtags used',
  are_you_want_to_grabbing_the_data: 'are you want to grab the hashtag data',
  we_are_retrieving_your_translated_tweets:
    'we are retrieving your translated tweets',
  waiting_to_grab_videos: 'waiting to grab videos',
  it_took_time_more_than_useual: 'it will take time more than usual',
  m: 'M',
  s: 'S',
  grabbing_influencer_come_later:
    'Working on grabbing it please try again after few minutes',
  top_mentions_images: 'top mentioned images',
  hashtag_summary: 'hashtag summary',
  influencers_entities: 'influencers/entities',
  potential_reach: 'potential reach',
  Tweets_classification: 'Tweets classification',
  tweets_type: 'Tweets Type',
  tweets_summary: 'tweets summary',
  type_of_tweets_media: 'type of tweets media',
  client_sources: 'client sources',
  top_mentions_influencer: 'top mentions influencers / entities',
  top_mentions_images: 'top mentions images',
  top_mentions_links: 'top mentions links',
  most_valued_tweets: 'most valued tweets',
  most_retweet_tweets: 'most retweet tweets',
  most_favorited_tweets: 'most favorited tweets',
  most_favorited_posts: 'most favorited posts',
  tweets_sentiment: 'tweets sentiment',
  the_link: 'link',
  image: 'image',
  tweet: 'tweet',
  the_influencer: 'influencer',
  this_Word_already: 'Words already exists please try something else',
  Sorry_Failed_To_Grabbed: 'Sorry, Failed To Grabbed',
  add_influencer_as_unanalyzes:
    'are you sure you want to add this influencer as unanalyzed influencer ?',
  open_in_twitter: 'open in twitter',
  open_in_youtube: 'open in youtube',
  youtube_vidoes: 'youtube videos',
  grabbing_entity_come_later: 'Working on grabbing entity',
  Frequent_word: 'most frequency ',
  grabbing_something: 'Working on grabbing ',
  retweets_count: 'Retweets Count',
  frequent_words: 'frequent words',
  frequent_Hashtag: 'frequent hashtag',
  sentiment_analysis: 'sentiment analysis',
  no_frequent_words_founded: 'no frequent words founded',
  no_frequent_hashtags_founded: 'no frequent hashtags founded',
  youtube_videos: 'youtube videos',
  hashtag_exists:
    'This hashtag exists in the system before ,  click here to show details  ',
  hashtag_exists_incomplete:
    'This hashtag exists in the system before as incomplete',
  check_it: 'check it',
  search_for: 'search for',
  Twitter: 'Twitter',
  Youtube: 'Youtube',
  csv_already_exists_category:
    'This file contain words that exists in another column',
  a_hashtag: 'hashtag',
  this_hashtag_trashed: 'This Hashtag is trashed, Do you want to restore it?',
  this_hashtag_unnecessary:
    'This Hashtag is unnecessary, Do you want to restore it?',
  grabbing_sentiment_analysis: 'Working on sentiment analysis for',
  total_posts: 'total posts',
  first_mention_post: '1st mention post',
  most_engaged_posts: 'most engaged posts',
  sentiment_videos: 'videos sentiment',
  sentiment_tweets: 'tweets sentiment',
  sentiment_linkedin: 'linkedIn sentiment',
  sentiment_instagram: 'instagram sentiment',
  most_favourite_videos: 'most favorited videos',
  first_mention_videos: '1st mention video',
  total_videos: 'total videos',
  most_viewed_videos: 'most viewed videos',
  first_mention_tweet: '1st mention tweet',
  posts_type: 'posts type',
  number: 'number',
  influencers_entities: 'influencers/entities',
  hashtag_sentiment_analysis: 'hashtag sentiment analysis',
  convert_Hashtag_to_Keyword:
    'The keyword you’re trying to add already exists as a hashtag. Proceeding with this action will convert the existing hashtag to a keyword.',
  proceed: 'proceed',
  please_select_platform: 'please select a platform',
  convert_message:
    'Are you Sure you want to convert this hashtag to an keyword ? ',
  convert_to_keyword: 'convert to keyword',
  tiktok_posts: 'tiktok posts',
  resync_hashtags: 'Re-Sync Hashtags',
  resync_related_hashtags:
    'working on Re-syncing the related hashtags, you’ll get notified once finished',
  Add_keyword: 'Add keyword',
  includes_word: `Include words separated by spaces (e.g., "new year").`,
  Add_Hashtag: 'Add hashtag',
  includes_hashtag: `Spaces are not permitted; use underscores (_) instead (e.g., "#new_year").`,
};

export const ar = {
  Add_keyword: 'إضافة كلمة',
  includes_word: `قم بتضمين الكلمات مفصولة بمسافات (على سبيل المثال، "عام جديد")`,
  Add_Hashtag: 'إضافة هاشتاق',
  includes_hashtag: ` لا يُسمح بوجود مسافات؛ استخدم الشرطة السفلية (_) بدلاً من ذلك (على سبيل المثال، "#عام_جديد")`,
  resync_related_hashtags:
    'جاري العمل على إعادة مزامنة الهاشتاقات ذات الصلة، وسيتم إخبارك بمجرد الانتهاء',
  resync_hashtags: 'جلب الهاشتاقات',
  tiktok_posts: 'منشورات التيك توك',
  convert_to_keyword: 'تحويل إلي كلمة',
  proceed: 'تابع',
  convert_message: 'هل انت متاكد انك تريد تحويل هذا الهاشتاق الي كلمه ؟',
  convert_Hashtag_to_Keyword:
    'الكلمة التي تحاول إضافتها موجودة بالفعل كهاشتاق. سيؤدي الاستمرار في هذا الإجراء إلى تحويل الهاشتاق الموجود إلى كلمة .',
  hashtag_sentiment_analysis: 'تحليل نسب الأراء للهاشتاق',
  influencers_entities: 'المؤثرون/الكيانات',
  number: 'العدد',
  posts_type: 'نوع التغريدات',
  first_mention_tweet: 'الإشاره الاولي للتغريده',
  most_viewed_videos: 'الفيديوهات الأكثر مشاهدة',
  total_videos: 'إجمالي الفيديوهات',
  first_mention_videos: 'الإشاره الاولي للفيديو',
  most_favourite_videos: 'الفيديوهات الأكثر تفضيلاً',
  sentiment_videos: 'تحليل نسب الاراء للفيديوهات',
  sentiment_tweets: 'تحليل نسب الاراء للتغريدات',
  sentiment_linkedin: 'تحليل نسب الاراء للينكدان',
  sentiment_instagram: 'تحليل نسب الاراء لاستغرام',
  most_engaged_posts: 'المنشورات الأكثر تفاعلاً',
  first_mention_post: 'الاشاره الاولي للمنشور',
  total_posts: 'إجمالي المنشورات',
  grabbing_sentiment_analysis: 'جاري العمل علي تحليل نسب الأراء ل',
  this_hashtag_trashed: 'هذاالهاشتاق تم حذفه ، هل تريد استعادته؟',
  this_hashtag_unnecessary: 'هذاالهاشتاق غير مهم  ، هل تريد استعادته؟',
  a_hashtag: 'هاشتاق',
  csv_already_exists_category:
    'هذا الملف يحتوى على كلمات موجوده بالفعل فى عمود اخر',
  Youtube: 'يوتيوب',
  Twitter: 'تويتر',
  check_it: 'التحقق منه',
  hashtag_exists: ' الهاشتاق تم اضافته من قبل ، انقر هنا لعرض التفاصيل ',
  hashtag_exists_incomplete: 'الهاشتاق تم اضافته من قبل على أنه غير مكتمل',
  no_frequent_words_founded: 'لا يوجد كلمات متكرره',
  no_frequent_hashtags_founded: 'لا يوجد هاشتاقات متكرره',
  sentiment_analysis: 'تحليل نسب الآراء',
  merge_warning:
    '(الدمج نهائي ولا يمكن التراجع عنه. سيتم حذف الهاشتاقات المدمجة ولا يمكن إضافتها مرة أخرى.)',
  frequent_words: 'الكلمات الأكثر تكراراً',
  Frequent_word: 'الكلمة مٌتكررة',
  frequent_Hashtag: 'الهاشتاق مُتكرر',
  grabbing_entity_come_later: 'جاري العمل على الكيان ',
  open_in_youtube: 'افتح في يوتيوب',
  open_in_twitter: 'افتح في تويتر ',
  select_inf: 'اختار الهاشتاج الرئيسي لاجل الدمج',
  add_influencer_as_unanalyzes:
    'هل انت متأكد انك تريد إضافة هذا المؤثر كمؤثر غير مٌحلل ؟',
  Sorry_Failed_To_Grabbed: 'عذراً حدث فشل في جلب البيانات',
  this_Word_already: ' يوجد كلمات موجوده من قبل برجاء المحاولة مرة اخري',
  top_mentions_images: 'الصور الأكثر إشارة',
  top_mentions_links: ' الروابط الأكثر إشارة',
  most_valued_tweets: ' التغريدات الأكثر قيمة',
  most_retweet_tweets: 'معظم التغريدات المٌعاد تغريدها',
  most_favorited_tweets: 'التغريدات الأكثر تفضيلاً',
  most_favorited_posts: 'المنشورات الأكثر تفضيلاً',
  tweets_sentiment: '  نسب الآراء للتغريدات',
  the_link: 'الرابط',
  youtube_videos: 'فيديوهات يوتيوب',
  image: 'الصورة',
  tweet: 'التغريدة',
  the_influencer: 'المؤثر',
  please_select_platform: 'الرجاء اختيار منصة',
  top_mentions_influencer: 'المؤثرين / الكيانات الأكثر إشارة',
  client_sources: 'مصادر التفاعل',
  type_of_tweets_media: 'نسب انتشار أنواع الوسائط للتغريدات ',
  tweets_summary: 'تحليل التغريدات',
  Tweets_classification: ' التغريدات وإعادة التغريد',
  tweets_type: 'انواع التغريدات',
  potential_reach: ' الوصول المحتمل',
  influencers_entities: 'المؤثرون/الكيانات',
  hashtag_summary: 'تحليل الهاشتاق',
  top_mentions_images: 'الصور الأكثر إشارة',
  s: 'ث',
  m: 'د',
  it_took_time_more_than_useual: 'قد يستغرق هذا وقتًا أكثر من المعتاد ',
  we_are_retrieving_your_translated_tweets:
    'يتم استرجاع التغريدات المترجمه الان',
  waiting_to_grab_videos: 'في انتظار جلب مقاطع الفيديو',

  moving_tweet: 'تم حفظ نقل التغريدات بنجاح ',
  are_you_want_to_grabbing_the_data:
    'هل انت متأكد انك تريد جلب بيانات الهاشتاق',

  selected_worlds: 'الكلمات المختاره',
  text_logs: 'السجلات',
  See_all: 'اظهار الكل',
  male: 'ذكر',
  csv_already_exists: 'هناك تكرار في الملف الذي تحاول رفعه',
  female: 'انثي',
  are_you_sure_you_want_to_cancel: 'هل أنت متأكد أنك تريد الإلغاء؟',
  following: 'تابع',
  followers: 'المُتابِعين ',
  likes_count: 'عدد الاعجابات',
  retweets_count: 'عدد اعادة النشر',
  influencer: 'مؤثر',
  mentions: 'الإشارات',
  hashtag: 'الهاشتاق',
  country: 'الدولة',
  last_seen: 'اخر ظهور',
  add_new_set: 'إضافة مجموعة جديده',
  csv: 'ملف csv',
  set: 'مجموعة',
  word: 'كلمة',
  this_hashtag_already_exists_please:
    'هذا الهاشتاق موجود بالفعل ، يرجى إضافة علامة تصنيف فريدة',
  done_edit_dashboard_view: 'تم التعديل بنجاح',
  go_back_until_we_finish: 'نعود حتى ننتهي',
  analyzing: 'تحليل',
  set_already_exists_in_a_column: '!المجموعة موجوده بالفعل في عمود',
  word_already_exists_in_a_column: '!الكلمة موجوده بالفعل في عمود',
  hashtag_already_exists_in_a_column: 'الهاشتاق موجود بالفعل في عمود!',
  Add_positive_words: 'أضف كلمات إيجابية',
  Add_neutral_words: 'أضف كلمات محايدة',
  Add_negative_words: 'أضف كلمات سلبية',
  Add_negative_items: 'أضف عناصر سلبيه',
  Add_neutral_items: 'أضف عناصر محايده  ',
  Add_positive_items: 'أضف عناصر ايجابيه ',
  This_field_is_required: 'هذه الحقل مطلوب ويجب أن لا يقل عن حرفين',
  maximum_word: 'هذه الحقل مطلوب ويجب أن لا يزيد عن 150 حرف',
  type_hashtag: 'أكتب الهاشتاق',
  type_keywords: 'أكتب الكلمات',
  edit_dashboard: 'تحرير القائمة الرئيسية',
  sets_tables: 'جدول المجموعات',
  trends: 'الترندات',
  negative: 'سلبي',
  neutral: 'محايد',
  positive: 'إيجابي',
  longest_mentioned: 'الأطول إشارة',
  most_mentioned: 'الأكثر إشارة',
  unnecessary: 'غير مهم',
  platforms_sources: 'مصدر المنصة',
  deleted_on: 'حذف في',
  set_name: 'اسم المجموعة',
  num_words: 'عدد الكلمات',
  word_name: 'اسم الكلمة',
  search_by_set: 'بحث بإسم المجموعة',
  search_by_hashtag: 'بحث بإسم الهاشتاق',
  select_data_you_want_regrab: 'حدد البيانات التي تريد إعادة جلبها',
  sets_words: 'كلمات المجموعة',
  modified_on: 'تم التعديل في',
  num_usage: 'الإستخدام',
  num_of_words: 'عدد الكلمات',
  trashed: 'محذوفات',
  created_by: ' تم الإنشاء بواسطة',
  hashtags: 'الهاشتاقات',
  add_hashtag: 'إضافة هاشتاق جديد',
  add_Hashtag: 'إضافة هاشتاق',
  add_keyword: 'إضافة كلمه',
  edit_hashtag: 'تعديل الهاشتاق',
  tweetTitle: 'عنوان التغريدة',
  influencerName: 'اسم النؤثر',
  likes: 'الإعجابات',
  retweets: 'إعادة النشر',
  replies: 'الردود',
  attachments: 'الملصقات',
  created_on: 'أنشأت في',
  un_analyzed_hashtags: 'الهاشتاقات غير المحللة',
  unnecessary_hashtags: 'الهاشتاقات غير المهمة',
  trending_hashtags: 'الهاشتاقات الترند',
  trending_hashtags_table: 'جدول الهاشتاقات الترند',
  analyzed_hashtags: 'الهاشتاقات المحللة',
  trashed_hashtags: 'الهاشتاقات المحذوفة',
  hashtags_dashboard: 'القائمة الرئيسية',
  hashtags_table: 'جدول الهاشتاقات',
  top_posts: 'أعلى المنشورات',
  search: 'بحث',
  tweet_title: 'عنوان التغريدة',
  influencer_name: 'اسم المؤثر',
  longest_trending: 'الأطول ترند ',
  hashtags_trending: 'الهاشتاقات الترند 24',
  has_imgs: 'لديه {{count}} صور',
  location: 'الموقع الجغرافي',
  hashtag_created: 'تمت إضافة الهاشتاق بنجاح، اذهب إلى ',
  hashtag_updated: 'تم التعديل بنجاح، اذهب إلى ',
  updated_done: 'تم التعديل بنجاح ',
  details_page: ' صفحة التفاصيل',
  go_to: 'إذهب إلى',
  influencer_entity: 'المؤثر / الكيان',
  Most_Frequent_word: 'أكثر الكلمات المتكررة',
  cant_view_sentiment: 'لا يمكن عرض وجهة النظر لان الهاشتاقات لسيت محللة',
  grabbing_hashtag: 'جاري العمل على جلب الهاشتاق ',
  merging_hashtag: 'جاري العمل على دمج الهاشتاقات ',
  come_later: 'يرجى المحاولة مرة أخرى بعد بضع دقائق',
  grabbing_influencer: 'جاري العمل على المؤثر ',
  grabbing_entity: 'جاري العمل على الكيان ',
  trending: 'الترندات',
  hashtags_used: 'الهاشتاقات المستخدمه',
  grabbing_something: ' جاري العمل على جلب',
  search_for: 'البحث عن',
};
